/*eslint-disable prefer-const */
import { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Formik, Form, useFormik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';

import Checkbox from 'src/Admin/components/common/Checkbox';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import AutoSuggestionSelectComponent from 'src/Components/auto-suggestion-select/Select';
import TextInput from 'src/Components/GenericInputText/TextInput';
import { formatPhoneNumber, stateOptions } from 'src/utils';
import { axiosInstance } from '../../../../../api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import ToastMessage from '../../../common/ToastMessage/index';
import '../styles/edit-contact-info.scss';

const phoneRegExp = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

const digitsOnly = (value) => (value ? /^\d+$/.test(value) : true);

const formattedStateOptions = [...stateOptions].map((v) => {
  return { label: v.stateTitle, value: v.State };
});

const validationSchema = yup.object({
  alternate_email: yup.string().email('Enter Valid Email Address').nullable(),
  mobile_phone: yup
    .string()
    .matches(phoneRegExp, 'Enter valid phone number')
    .nullable(),
  home_phone: yup
    .string()
    .matches(phoneRegExp, 'Enter valid phone number')
    .nullable(),
  work_phone: yup
    .string()
    .matches(phoneRegExp, 'Enter valid phone number')
    .nullable(),
  work_phone_ext: yup
    .string()
    .test('Digits only', 'The field should have digits only', digitsOnly)
    .min(0)
    .max(5),
  residence_street: yup.string().required('Enter street Address').max(55),
  residence_apartment: yup.string().max(55).nullable(),
  residence_city: yup.string().required('Enter city').min(0).max(30),
  //residence_state: yup.object().required('Enter State').min(0).max(30),
  residence_state: yup.object().required('Enter State'),
  residence_zip: yup.string().required('Enter postal code').min(0).max(15),
  DifferentMailingAddress: yup.boolean(),
  mailing_street: yup
    .string()
    .max(55)
    .when('DifferentMailingAddress', {
      is: (value) => value === true,
      then: (schema) => schema.required('Enter street Address'),
      otherwise: (schema) => schema,
    }),
  mailing_apartment: yup.string().max(55).nullable(),
  mailing_city: yup
    .string()
    .min(0)
    .max(30)
    .when('DifferentMailingAddress', {
      is: (value) => value === true,
      then: (schema) => schema.required('Enter city'),
      otherwise: (schema) => schema,
    }),
  mailing_state: yup
    .string()
    .nullable()
    .when('DifferentMailingAddress', {
      is: (value) => value === true,
      then: (schema) => schema.required('Enter state'),
      otherwise: (schema) => schema,
    }),
  mailing_zip: yup
    .string()
    .min(0)
    .max(15)
    .when('DifferentMailingAddress', {
      is: (value) => value === true,
      then: (schema) => schema.required('Enter postal code'),
      otherwise: (schema) => schema,
    }),
});

const EditMemberContactInfo = ({
  onCancel,
  data,
  isDependentSelected,
  isMemberSelected,
  onSuccessfulSubmit,
  MemberEditPermissions,
  DependentEditPermissions,
}) => {
  console.log('********* >>>>>', data);
  let PhoneEmailInfo, residentialAddress, mailingAddress;

  PhoneEmailInfo = data?.PhoneEmailInfo;
  residentialAddress = data?.residentialAddress;
  mailingAddress = data?.mailingAddress;
  const [loader, setLoader] = useState(false);
  const [useDifferentMailingAddress, setUseDifferentMailingAddress] =
    useState(false);
  const [cancelEdit, setcancelEdit] = useState(false);
  const [contactDetailsSaveSuccess, setContactDetailsSaveSuccess] =
    useState(false);
  const [addressDetailsSaveSuccess, setAddressDetailsSaveSuccess] =
    useState(false);

  const permissions = isMemberSelected
    ? MemberEditPermissions
    : DependentEditPermissions;
  const getAddressLine = (address) => {
    return `${address?.Address1} ${
      address?.Address2 ? address?.Address2 : ''
    } ${address?.Address3 ? address?.Address3 : ''} ${
      address?.County ? address?.County : ''
    } ${address?.City ? address?.City : ''}, ${
      address?.State ? address?.State : ''
    }`;
  };
  const noValue = 'Not Specified';
  const mailing_address =
    mailingAddress?.Address1 && mailingAddress?.Address1
      ? getAddressLine(mailingAddress)
      : noValue;
  useEffect(() => {
    if (
      contactDetailsSaveSuccess === true &&
      addressDetailsSaveSuccess === true
    ) {
      onSuccessfulSubmit();
    }
  }, [contactDetailsSaveSuccess, addressDetailsSaveSuccess]);

  const initialValues = {
    primary_email: PhoneEmailInfo.Email1,
    alternate_email: PhoneEmailInfo.Email2 || '',
    //mobile_phone: formatPhoneNumber(PhoneEmailInfo.CellPhone1),
    mobile_phone: formatPhoneNumber(PhoneEmailInfo.MobilePhone) || '',
    home_phone: formatPhoneNumber(PhoneEmailInfo.HomePhone) || '',
    work_phone: formatPhoneNumber(PhoneEmailInfo.WorkPhone) || '',
    work_phone_ext: '',
    residence_street: residentialAddress?.Address1,
    residence_apartment: residentialAddress?.Address2,
    residence_city: residentialAddress?.City,
    residence_state: residentialAddress?.State
      ? formattedStateOptions.filter(
          (v) => v.value === residentialAddress?.State,
        )[0]
      : null,
    residence_zip: residentialAddress?.PostalCode,
    DifferentMailingAddress: useDifferentMailingAddress,
    mailing_street: mailingAddress?.Address1,
    mailing_apartment: mailingAddress?.Address2,
    mailing_city: mailingAddress?.City,
    mailing_state: mailingAddress?.State,
    mailing_zip: mailingAddress?.PostalCode,
  };

  //function to save Phone number and Alternate Email id
  const submitPhoneAndEmail = async (values) => {
    let urlToSubmit = '';

    const sanitizePhoneNumber = (num) => {
      return num.replace('(', '').replace(')', '').replace(/ /g, '');
    };

    //alternate_email, mobile_phone, home_phone, work_phone
    if (values.alternate_email) {
      urlToSubmit += `alternateemail/${values.alternate_email}/`;
    }
    if (values.mobile_phone) {
      urlToSubmit += `mobilephone/${sanitizePhoneNumber(values.mobile_phone)}/`;
    }
    if (values.home_phone) {
      urlToSubmit += `homephone/${sanitizePhoneNumber(values.home_phone)}/`;
    }
    if (values.work_phone) {
      urlToSubmit += `workphone/${sanitizePhoneNumber(values.work_phone)}/`;
    }

    try {
      if (data?.selectedMember.mType === 'Employee' && isMemberSelected) {
        const response = await axiosInstance.put(
          `${APIEndpoints.updateMember()}${urlToSubmit}/oid/${
            data.selectedMember.ID
          }`,
        );
        return response;
      }
      if (data?.selectedMember.mType === 'Employee' && isDependentSelected) {
        return await axiosInstance.put(
          `${APIEndpoints.updateDependent()}${urlToSubmit}/oid/${
            data?.activeDependentId
          }`,
        );
      }
      if (data?.selectedMember.mType === 'Dependent') {
        const response = await axiosInstance.put(
          `${APIEndpoints.updateDependent()}${urlToSubmit}/oid/${
            data?.selectedMember.ID
          }`,
        );
        return response;
      }
      setContactDetailsSaveSuccess(true);
    } catch (error) {
      console.log('error occurred in updating member data', error);
    }
  };

  //function to save Address Values
  const submitAddresses = async (values) => {
    const updatedResidenceAddress = {
      EffectiveDate: residentialAddress?.EffectiveDate,
      Address1: values?.residence_street,
      Address2: values?.residence_apartment,
      Address3: residentialAddress?.Address3,
      County:
        residentialAddress?.City !== values?.residence_city ||
        residentialAddress?.State !== values?.residence_state ||
        residentialAddress?.PostalCode !== values?.residence_zip
          ? null
          : residentialAddress?.County,
      Country: 'USA',
      City: values?.residence_city,
      States: values?.residence_state?.value,
      PostalCode: values?.residence_zip,
    };
    let updatedMailingAddress = { ...updatedResidenceAddress };
    updatedMailingAddress.EffectiveDate = mailingAddress?.EffectiveDate;
    if (useDifferentMailingAddress === true) {
      updatedMailingAddress = {
        EffectiveDate: mailingAddress?.EffectiveDate,
        Address1: values?.mailing_street,
        Address2: values?.mailing_apartment,
        Address3: mailingAddress?.Address3,
        County:
          mailingAddress?.City != values?.mailing_city ||
          mailingAddress?.State != values?.mailing_state ||
          mailingAddress?.PostalCode != values?.mailing_zip
            ? null
            : mailingAddress?.County,
        Country: 'USA',
        City: values?.mailing_city,
        States: values?.mailing_state?.value,
        PostalCode: values?.mailing_zip,
      };
    }
    const memberAddressDetails = {
      UpdateMemberAddress: {
        EmployeeMaintenanceAdd: [updatedResidenceAddress],
        EmployeeMailingAdd: [updatedMailingAddress],
      },
    };
    const dependentAddressDetails = {
      UpdateDependentAddress: {
        DependentMaintenanceAdd: [updatedResidenceAddress],
        DependentMailingAddess: [updatedMailingAddress],
      },
    };

    if (data?.selectedMember.mType === 'Employee' && isMemberSelected) {
      return await axiosInstance.put(
        `${APIEndpoints.updateMemberAddress()}/oid/${data?.selectedMember.ID}`,
        memberAddressDetails,
      );
    } else if (
      data?.selectedMember.mType === 'Employee' &&
      isDependentSelected
    ) {
      return await axiosInstance.put(
        `${APIEndpoints.updateDependentAddress()}/oid/${
          data?.activeDependentId
        }`,
        dependentAddressDetails,
      );
    } else {
      return await axiosInstance.put(
        `${APIEndpoints.updateDependentAddress()}/oid/${
          data?.selectedMember.ID
        }`,
        dependentAddressDetails,
      );
    }
  };

  const handleSubmit = async (values) => {
    setLoader(true);
    setAddressDetailsSaveSuccess(false);
    setContactDetailsSaveSuccess(false);

    try {
      if (
        values.home_phone !== (initialValues.home_phone || '') ||
        values.work_phone !== (initialValues.work_phone || '') ||
        values.mobile_phone !== (initialValues.mobile_phone || '') ||
        values.alternate_email !== (initialValues.alternate_email || '')
      ) {
        submitPhoneAndEmail(values)
          .then(() => {
            toast.success(
              <ToastMessage
                type="success"
                subTitle="Contact details submitted successfully."
              />,
            );
          })
          .catch((e) => {
            toast.error(
              <ToastMessage
                type="error"
                subTitle="Some error occurred. Please try again later."
              />,
            );
          });
        setContactDetailsSaveSuccess(true);
      } else {
        //setContactDetailsSaveSuccess(true);
      }
    } catch (error) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Some error occurred updating contact details. Please try again."
        />,
      );
    } finally {
      setLoader(false);
    }

    if (
      values.residence_street !== initialValues.residence_street ||
      values.residence_apartment !== initialValues.residence_apartment ||
      values.residence_city !== initialValues.residence_city ||
      values.residence_state?.value !== initialValues.residence_state?.value ||
      values.residence_zip !== initialValues.residence_zip ||
      values.mailing_street !== initialValues.mailing_street ||
      values.mailing_apartment !== initialValues.mailing_apartment ||
      values.mailing_city !== initialValues.mailing_city ||
      values.mailing_state?.value !== initialValues.mailing_state?.value ||
      values.mailing_zip !== initialValues.mailing_zip
    ) {
      try {
        await submitAddresses(values);
        toast.success(
          <ToastMessage type="success" subTitle="Address saved successfully" />,
        );
        setAddressDetailsSaveSuccess(true);
        //getMemberData();
      } catch (error) {
        console.log(error);
        setAddressDetailsSaveSuccess(false);
        toast.error(
          <ToastMessage
            type="error"
            subTitle="Some error occurred updating address(es). Please try again."
          />,
        );
      } finally {
        setLoader(false);
      }
    } else {
      setAddressDetailsSaveSuccess(true);
    }
  };
  const handleCancelEdit = () => {
    onCancel();
  };
  return (
    <Container className="edit-member-contact-info p-0">
      <div className="my-profile-member-container">
        <div>
          <h2 className="row-title" tabIndex={0}>
            Contact Information
          </h2>
        </div>
      </div>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          //submitPhoneAndEmail(values);
          handleSubmit(values);
        }}
        validateOnChange
        validateOnBlur
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
          setFieldValue,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row className="form-main-container m-0">
                <Col md={12} className="p-0 m-0">
                  {/*primary email */}
                  <Col md={12} className="form-input-row">
                    <TextInput
                      footerLabel={
                        !errors.primary_email
                          ? ''
                          : //<label className="hint-text">
                            //Based on your permission, you can edit this email ID
                            //from
                            //<span> Registered Email</span> section
                            //</label>
                            null
                      }
                      label={'Email'}
                      isRequired
                      inputProps={{
                        id: 'primary-email-edit',
                        placeholder: 'Primary Email',
                        value: values.primary_email,
                        name: 'primary_email',
                        onChange: (e) => {
                          handleChange(e);
                        },
                        readOnly: true,
                        disabled: true,
                      }}
                      feedBackMessage={
                        errors.primary_email ? errors.primary_email : null
                      }
                    />
                  </Col>
                  {/*Alternate email */}
                  <Col md={12} className="form-input-row">
                    <TextInput
                      label={'Alternative Email'}
                      inputProps={{
                        id: 'alternate-email-edit',
                        placeholder: 'Alternative email',
                        value: values.alternate_email,
                        name: 'alternate_email',
                        onChange: handleChange,
                        disabled:
                          !permissions?.editContact ||
                          !permissions?.editAlternateEmail,
                      }}
                      feedBackMessage={
                        errors.alternate_email ? errors.alternate_email : null
                      }
                    />
                  </Col>
                  <Row>
                    {/*Mobile phone */}
                    <Col md={6} className="form-input-row-mb">
                      <label>Mobile</label>
                      <Row>
                        <Col md={2} className="pr-0">
                          <TextInput
                            inputProps={{
                              id: 'mobile-cell-cc',
                              value: '+1',
                              disabled: true,
                              readOnly: true,
                            }}
                          />
                        </Col>
                        <Col md={10}>
                          <TextInput
                            isRequired
                            inputProps={{
                              id: 'mobile-cell-phone',
                              placeholder: 'Mobile phone',
                              value: values.mobile_phone,
                              name: 'mobile_phone',
                              onChange: handleChange,
                              onKeyUp: (e) => {
                                e.target.value = formatPhoneNumber(
                                  e.target.value,
                                );
                                setFieldValue('mobile_phone', e.target.value);
                              },
                              onBlur: handleChange,
                            }}
                            feedBackMessage={errors.mobile_phone}
                          />
                        </Col>
                      </Row>
                    </Col>

                    {/*Home phone */}
                    <Col md={6} className="form-input-row-mb">
                      <label>Home Phone</label>
                      <Row>
                        <Col md={2} className="pr-0">
                          <TextInput
                            inputProps={{
                              id: 'mobile-home-cc',
                              value: '+1',
                              disabled: true,
                              readOnly: true,
                            }}
                          />
                        </Col>
                        <Col md={10}>
                          <TextInput
                            isRequired
                            inputProps={{
                              id: 'mobile-home-phone',
                              placeholder: 'Home phone',
                              value: values.home_phone,
                              name: 'home_phone',
                              onChange: handleChange,
                              onKeyUp: (e) => {
                                e.target.value = formatPhoneNumber(
                                  e.target.value,
                                );
                                setFieldValue('home_phone', e.target.value);
                              },
                              onBlur: handleChange,
                            }}
                            feedBackMessage={errors.home_phone}
                          />
                        </Col>
                      </Row>
                    </Col>
                    {/*</Col>*/}
                  </Row>
                  {/*Work Phone */}
                  <Col md={12} className="form-input-row">
                    <label>Work Phone</label>
                    <Row>
                      <Col md={1} className="pr-0">
                        <TextInput
                          label={''}
                          inputProps={{
                            id: 'mobile-work-cc',
                            value: '+1',
                            disabled: true,
                            readOnly: true,
                          }}
                        />
                      </Col>
                      <Col md={5}>
                        <TextInput
                          label={''}
                          inputProps={{
                            id: 'mobile-work-phone',
                            placeholder: 'Work phone',
                            value: values.work_phone,
                            name: 'work_phone',
                            onChange: handleChange,
                            onKeyUp: (e) => {
                              e.target.value = formatPhoneNumber(
                                e.target.value,
                              );
                              setFieldValue('work_phone', e.target.value);
                            },
                            onBlur: handleChange,
                          }}
                          feedBackMessage={errors.work_phone}
                        />
                      </Col>
                      <Col md={6} className="margin-set">
                        <TextInput
                          label={'Extn'}
                          inputProps={{
                            id: 'mobile-work-phone-ext',
                            placeholder: 'Enter Extension',
                            value: values.work_phone_ext,
                            name: 'work_phone_ext',
                            readOnly: true,
                            disabled: true,
                            //onChange: handleChange,
                          }}
                          feedBackMessage={errors.work_phone_ext}
                        />
                      </Col>
                    </Row>
                  </Col>

                  {/*Residential Address */}
                  <Col md={12} className="form-input-row">
                    <p className="residence-main-heading p-0 m-0">
                      Residential Address
                    </p>
                    <TextInput
                      label={'Street Address'}
                      isRequired
                      inputProps={{
                        value: values.residence_street,
                        id: 'res-add-street',
                        placeholder: 'Street address',
                        //onChange: handleChange,
                        name: 'residence_street',
                        //disabled: !permissions?.editAddress,
                        readOnly: true,
                        disabled: true,
                      }}
                      feedBackMessage={errors.residence_street}
                    />
                  </Col>
                  <Col md={12} className="form-input-row">
                    <TextInput
                      label={'Apartment/Suit'}
                      inputProps={{
                        value: values.residence_apartment,
                        id: 'res-add-suit',
                        placeholder: 'Apartment/Suit',
                        //onChange: handleChange,
                        name: 'residence_apartment',
                        //disabled: !permissions?.editAddress,
                        readOnly: true,
                        disabled: true,
                      }}
                    />
                  </Col>
                  <Row className="form-input-row ">
                    <Col md={6}>
                      <TextInput
                        label={'City'}
                        isRequired
                        inputProps={{
                          value: values.residence_city,
                          id: 'res-add-city',
                          placeholder: 'City',
                          //onChange: handleChange,
                          name: 'residence_city',
                          //disabled: !permissions?.editAddress,
                          disabled: true,
                          readOnly: true,
                        }}
                        feedBackMessage={errors.residence_city}
                      />
                    </Col>
                    <Col md={6}>
                      {/*<TextInput
                        label={'State'}
                        isRequired
                        inputProps={{
                          value: values.residence_state,
                          id: 'res-add-state',
                          placeholder: 'State',
                          onChange: handleChange,
                          name: 'residence_state',
                        }}

                      />*/}
                      <label className="form-label" htmlFor={'res-state-id'}>
                        {'State'}
                        <span aria-hidden={true} className="mandatory-field">
                          *
                        </span>
                      </label>
                      <AutoSuggestionSelectComponent
                        options={formattedStateOptions}
                        name="residence_state"
                        placeholder="State"
                        inputClassName="resi_state dynamic-disable-state"
                        components={{ IndicatorSeparator: () => null }}
                        value={values.residence_state}
                        onChange={(e) => {
                          const event = {
                            target: {
                              name: 'residence_state',
                              value: e,
                            },
                          };
                          handleChange(event);
                        }}
                        //isDisabled={!permissions?.editAddress}
                        isDisabled={true}
                        //fieldTouch={setFieldTouched}
                        //isSearchable={false}
                        isRequired={true}
                        //isInvalid={touched.question1 && errors.question1}
                      />
                    </Col>
                  </Row>
                  <Col md={6} className="form-input-row-mb pl-0">
                    <TextInput
                      label={'Zip'}
                      isRequired
                      inputProps={{
                        value: values.residence_zip,
                        id: 'res-add-zip',
                        placeholder: 'Zip',
                        //onChange: handleChange,
                        name: 'residence_zip',
                        //disabled: !permissions?.editAddress,
                        disabled: true,
                        readOnly: true,
                      }}
                      feedBackMessage={errors.residence_zip}
                    />
                  </Col>
                  {/*<Col
                    md={12}
                    className="form-input-row mailing-address-checkbox"
                  >
                    <Checkbox
                      label={'Use a different mailing address'}
                      checked={useDifferentMailingAddress}
                      onChange={() => {
                        setUseDifferentMailingAddress(
                          !useDifferentMailingAddress,
                        );
                      }}
                      isDisabled={!permissions?.editAddress}
                      name="DifferentMailingAddress"
                    />
                  </Col> */}
                  {/*{Mailing address block starts here}*/}
                  {/*{useDifferentMailingAddress ? ( */}
                  {mailing_address !== 'Not Specified' ? (
                    <>
                      <Col md={12} className="form-input-row">
                        <p className="residence-main-heading p-0 m-0">
                          Mailing Address
                        </p>
                        <TextInput
                          label={'Street Address'}
                          isRequired
                          inputProps={{
                            value: values.mailing_street,
                            id: 'mail-add-street',
                            placeholder: 'Street address',
                            //onChange: handleChange,
                            name: 'mailing_street',
                            //disabled: !permissions?.editAddress,
                            disabled: true,
                            readOnly: true,
                          }}
                          feedBackMessage={errors.mailing_street}
                        />
                      </Col>
                      <Col md={12} className="form-input-row">
                        <TextInput
                          label={'Apartment/Suit'}
                          inputProps={{
                            value: values.mailing_apartment,
                            id: 'mail-add-suit',
                            placeholder: 'Apartment/Suit',
                            //onChange: handleChange,
                            name: 'mailing_apartment',
                            //disabled: !permissions?.editAddress,
                            disabled: true,
                            readOnly: true,
                          }}
                        />
                      </Col>
                      <Row className="form-input-row ">
                        <Col md={6}>
                          <TextInput
                            label={'City'}
                            isRequired
                            inputProps={{
                              value: values.mailing_city,
                              id: 'mail-add-city',
                              placeholder: 'City',
                              //onChange: handleChange,
                              name: 'mailing_city',
                              //disabled: !permissions?.editAddress,
                              disabled: true,
                              readOnly: true,
                            }}
                            feedBackMessage={errors.mailing_city}
                          />
                        </Col>
                        <Col md={6}>
                          {/*<TextInput
                            label={'State'}
                            isRequired
                            inputProps={{
                              value: values.mailing_state,
                              id: 'mail-add-state',
                              placeholder: 'State',
                              onChange: handleChange,
                              name: 'mailing_state',
                            }}
                          />*/}

                          <label
                            className="form-label"
                            htmlFor={'mail-state-id'}
                          >
                            {'State'}
                            <span
                              aria-hidden={true}
                              className="mandatory-field"
                            >
                              *
                            </span>
                          </label>

                          <AutoSuggestionSelectComponent
                            id={'mail-state-id'}
                            options={formattedStateOptions}
                            name="residence_state"
                            placeholder="State"
                            components={{ IndicatorSeparator: () => null }}
                            value={values.mailing_state}
                            onChange={(e) => {
                              const event = {
                                target: {
                                  name: 'mailing_state',
                                  value: e,
                                },
                              };
                              handleChange(event);
                            }}
                            isDisabled={true}
                            //isDisabled={!permissions?.editAddress}
                            //fieldTouch={setFieldTouched}
                            //isSearchable={false}
                            isRequired={true}
                            //isInvalid={touched.question1 && errors.question1}
                          />
                        </Col>
                      </Row>
                      <Col md={6} className="form-input-row-mb pl-0">
                        <TextInput
                          label={'Zip'}
                          isRequired
                          inputProps={{
                            value: values.mailing_zip,
                            id: 'mail-add-zip',
                            placeholder: 'Zip',
                            //onChange: handleChange,
                            name: 'mailing_zip',
                            //disabled: !permissions?.editAddress,
                            disabled: true,
                            readOnly: true,
                          }}
                          feedBackMessage={errors.mailing_zip}
                        />
                      </Col>
                    </>
                  ) : (
                    ''
                  )}
                  {/*{Mailing address block ends here}*/}

                  <Col
                    md={12}
                    className="form-input-row d-flex justify-content-between"
                  >
                    {/*<Checkbox label={'Update same address for Dependent(s)'} /> */}
                    <div className="text-right">
                      <GenericButton type="submit" onClick={handleSubmit}>
                        Update
                      </GenericButton>
                      <GenericButton
                        variant={'link'}
                        onClick={handleCancelEdit}
                      >
                        Cancel
                      </GenericButton>
                    </div>
                  </Col>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>

      {/*{cancelEdit ? (
        isMemberSelected ? (
          <UserProfile
            loader={data?.loader}
            employeeInfo={data?.employeeInfo}
            loggedInMemberType={data?.selectedMember.mType}
            loggedInUserOID={data?.selectedMember.ID}
            residentialAddress={data?.residentialAddress}
            mailingAddress={data?.mailingAddress}
            PhoneEmailInfo={data?.PhoneEmailInfo}
            employmentDetails={data?.employmentDetails}
            serverError={data?.serverError}
          />
        ) : (
          <Dependents
            fetchDependentsData={data?.fetchDependentsData}
            dependentsData={data?.dependentsData}
          />
        )
      ) : (
        ''
      )}
      {submitMemberAddress === true && (
        <UserProfile
          employeeInfo={data?.employeeInfo}
          loggedInMemberType={data?.selectedMember.mType}
          loggedInUserOID={data?.selectedMember.ID}
          residentialAddress={residentialData}
          mailingAddress={mailingData}
          submitMemberAddress={submitMemberAddress}
        />
      )}

      {submitDependentAddress === true ? (
        isDependentSelected ? (
          <Dependents
            fetchDependentsData={data?.fetchDependentsData}
            dependentsData={data?.dependentsData}
          />
        ) : (
          <UserProfile
            employeeInfo={data?.employeeInfo}
            loggedInMemberType={data?.selectedMember.mType}
            loggedInUserOID={data?.selectedMember.ID}
            residentialAddress={residentialData}
            mailingAddress={mailingData}
            submitMemberAddress={submitMemberAddress}
          />
        )
      ) : (
        ''
      )}*/}
    </Container>
  );
};

export default EditMemberContactInfo;
